<template>
  <router-view></router-view>
</template>

<script>
  export default {
    name: "SimpleLayout"
  }
</script>

<style scoped>

</style>